import React from "react";
import { observer } from "mobx-react";
import SAPCustomerPicker from "../SAPpickers/SAPCustomerPicker";
import { QuoteCustomerModel } from "./QuoteModel";
import Quotations from "./Quotations";
import SAPCustomerSalesOrgPicker from "../SAPpickers/SAPCustomerSalesOrgPicker";
import useDocumentTitle from "../layout/title";
import {
  Box,
  Button,
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMsal } from "@azure/msal-react";

const store = QuoteCustomerModel.create({});
const Quotes = ({ language, sys = "" }) => {
  window.localStorage.setItem("QUOTEsys", sys);
  useDocumentTitle("Quotes " + sys);
  store.setMsal(useMsal());
  if (store.SelectedSSP > -1) {
    return <Quotations customer={store.SSPItem} store={store} />;
  }
  return (
    <Box m={1} p={1} style={{ background: "white" }}>
      <Grid container>
        <Grid item xs={12} md={6}>
          <SAPCustomerPicker
            title="Customer"
            value={store.Customer}
            updatefunc={store.setCustomer}
            isClearable
            extrafilter=" and AccountGroup eq '0001' or AccountGroup eq '0100'"
            extraSelect=",City,Country"
          />
        </Grid>
        {store.Customer && (
          <Grid item xs={12} md={6} key={store.Customer.Id}>
            <SAPCustomerSalesOrgPicker
              title="Sales org"
              value={store.SalesOrg}
              updatefunc={store.setSalesOrg}
              customer={store.Customer.Id}
            />
          </Grid>
        )}
        {store.SalesOrg && (
          <p>
            <Button
              variant="outlined"
              color="secondary"
              onClick={store.getSSP}
              disabled={!(store.Customer && store.SalesOrg)}
            >
              search Customer
            </Button>
          </p>
        )}
        <Grid item xs={12}>
          <TableContainer>
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <h3>Sold to</h3>
                  </TableCell>
                  <TableCell>
                    <h3>Ship to</h3>
                  </TableCell>
                  <TableCell>
                    <h3>Payer</h3>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {store.loading &&
                  [1, 2].map((el) => (
                    <TableRow key={el}>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                      <TableCell>
                        <Skeleton />
                      </TableCell>
                    </TableRow>
                  ))}
                {store.SSP.map((el, i) => (
                  <TableRow
                    key={el.Payer + el.ShipTo + el.SoldTo}
                    hover
                    onClick={() => {
                      console.log(el);
                      console.log(i);
                      store.selectSSP(i);
                    }}
                  >
                    <TableCell>
                      ({el.SoldTo}) {el.SoldToName}
                    </TableCell>
                    <TableCell>
                      ({el.ShipTo}) {el.ShipToName} [{el.ShipToCountry}{" "}
                      {el.ShipToPostcode} {el.ShipToLocation} (
                      {el.ShipToStreetNr})]
                    </TableCell>
                    <TableCell>
                      ({el.Payer}) {el.PayerName}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default observer(Quotes);
